import { render, staticRenderFns } from "./Alzaad.vue?vue&type=template&id=641e8ad5"
import script from "./Alzaad.vue?vue&type=script&lang=js"
export * from "./Alzaad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports